import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearClientBalanceSlice,
  clearDashboardFilter,
} from "../../../../data/redux/slice/countsSlice";
import { clearGlobalFilterReducer } from "../../../../data/redux/slice/globalFiltersSlice";
import {
  fetchClientDropDownList,
  fetchResellerDropDownList,
  fetchResellerServiceProviderDropDownList,
  fetchServiceProviderDropDownList,
} from "../../../../services/fetchDropdownListData";
import {
  fetchAllRoleCounts,
  fetchClientBalance,
  fetchClientPayoutBalance,
  fetchClientVoucherBalance,
  getAllDashboardTransactionCount,
  getAllDashboardVolumeCount,
  getAllSettlementCount,
  updateMainTransactions,
} from "../../../../services/fetchListingData";
import secureStorage from "../../../../services/secureStorage";
import {
  SS_INTERNAL,
  SS_ROLE,
} from "../../../../utility/constants/secureStorageManager";
import { CLIENT, RESELLER } from "../../../../utility/constants/valueConstants";
import CustomDatePicker from "../../../components/main_comps/custom_date_picker";
import CustomSelect from "../../../components/main_comps/custom_select";
import RowButton from "../../../components/ui_comps/RowButton";
import { useSnackbar } from "notistack";
function FilterModal({ onClose }) {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedReseller, setSelectedReseller] = useState("");

  const [selectedServiceProvider, setSelectedServiceProvider] = useState("");
  const clientList = useSelector((state) => state.dropDownListSlice.clientList);
  const role = secureStorage.getItem(SS_ROLE);

  const internal = secureStorage.getItem(SS_INTERNAL);

  const serviceProvider = useSelector(
    (state) => state.dropDownListSlice.serviceProviderNameList
  );
  const filters = useSelector((state) => state.globalFiltersSlice);
  const { enqueueSnackbar } = useSnackbar();
  const resellerList = useSelector(
    (state) => state.dropDownListSlice.resellerList
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchClientDropDownList());
    dispatch(fetchResellerDropDownList());

    if (role?.toUpperCase() === RESELLER) {
      dispatch(fetchResellerServiceProviderDropDownList());
    } else {
      dispatch(fetchServiceProviderDropDownList());
    }
  }, []);

  const calculateMaxDate = () => {
    if (fromDate) {
      const fromDateObject = new Date(fromDate);
      fromDateObject.setMonth(fromDateObject.getMonth() + 1);
      return fromDateObject.toISOString().split("T")[0];
    }
    return null;
  };

  useEffect(() => {
    calculateMaxDate();
  }, [fromDate]);

  return (
    <div
      style={{
        maxHeight: 500,
        overflow: "scroll",
        position: "relative",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 300,
        flexDirection: "column",
        height: "100%",
        paddingTop: 20,
      }}
      className="hide-scroll-bar"
    >
      <div
        style={{
          width: "100%",
        }}
      >
        <>
          <div style={{ marginTop: 20 }}>
            <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
              From
            </label>
            <CustomDatePicker
              value={fromDate}
              onChange={(val) => {
                setFromDate(val);
                setToDate("");
              }}
            />
          </div>
          <div style={{ marginTop: 20 }}>
            <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
              To
            </label>
            <CustomDatePicker
              value={toDate}
              onChange={setToDate}
              minDate={fromDate}
              maxDate={calculateMaxDate()}
              disabled={fromDate ? false : true}
            />
          </div>
        </>
      </div>

      {role !== CLIENT && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Client
          </label>

          <CustomSelect
            value={selectedClient}
            options={clientList}
            onChange={(data) => {
              setSelectedClient(data);
            }}
            placeholder={"Select client"}
            style={{
              width: "100%",
              minWidth: 400,
            }}
          />
        </div>
      )}

      {role?.toUpperCase() !== RESELLER && role?.toUpperCase() !== CLIENT && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Reseller
          </label>

          <CustomSelect
            value={selectedReseller}
            options={resellerList}
            onChange={(data) => setSelectedReseller(data)}
            placeholder={"Select reseller "}
            style={{
              width: "100%",
              minWidth: 400,
            }}
          />
        </div>
      )}

      {role?.toUpperCase() !== RESELLER && role?.toUpperCase() !== CLIENT && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Service Provider
          </label>

          <CustomSelect
            value={selectedServiceProvider}
            options={serviceProvider}
            onChange={(data) => {
              setSelectedServiceProvider(data);
            }}
            placeholder={"Select service provider"}
            style={{
              width: "100%",
              minWidth: 400,
            }}
          />
        </div>
      )}

      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "center",
          position: "sticky",
          bottom: 0,
        }}
      >
        <RowButton
          onClickBack={() => {
            dispatch(clearGlobalFilterReducer());
            dispatch(clearDashboardFilter(false));
            dispatch(clearClientBalanceSlice());

            dispatch(
              fetchClientBalance({
                clientId: "",
                resellerId: "",
                serviceProviderName: "",
              })
            );

            dispatch(
              fetchClientVoucherBalance({
                clientId: "",
                resellerId: "",
                serviceProviderName: "",
              })
            );

            dispatch(
              fetchClientPayoutBalance({
                clientId: "",
                resellerId: "",
              })
            );

            dispatch(
              getAllDashboardVolumeCount({
                clientId: "",
                resellerId: "",
                rootReferenceId: "",
              })
            );
            dispatch(
              getAllDashboardTransactionCount({
                clientId: "",
                resellerId: "",
                rootReferenceId: "",
              })
            );
            dispatch(
              getAllSettlementCount({
                dateRange: "",
                serviceType: "",
                userId: "",
                userRefId: "",
                serviceProviderName: "",
              })
            );
            dispatch(
              updateMainTransactions({
                clientId: "",
                resellerId: "",
                rootReferenceId: "",
              })
            );

            onClose();
          }}
          onClickNext={() => {
            dispatch(clearDashboardFilter(true));
            dispatch(
              getAllSettlementCount({
                dateRange:
                  fromDate && toDate
                    ? moment(fromDate).format("DD/MM/YYYY") +
                      "-" +
                      moment(toDate).format("DD/MM/YYYY")
                    : "",
                serviceType: "",
                userId: selectedClient.value ?? "",
                userRefId: selectedReseller.value ?? "",
                serviceProviderName: selectedServiceProvider?.value ?? "",
              })
            );
            dispatch(
              updateMainTransactions({
                clientId: selectedClient.value ?? "",
                resellerId: selectedReseller.value ?? "",
                rootReferenceId: "",
              })
            );
            dispatch(
              fetchClientBalance({
                clientId: selectedClient.value ?? "",
                resellerId: selectedReseller.value ?? "",
                serviceProviderName: selectedServiceProvider?.value ?? "",
              })
            );
            dispatch(
              fetchClientVoucherBalance({
                clientId: selectedClient.value ?? "",
                resellerId: selectedReseller.value ?? "",
                serviceProviderName: selectedServiceProvider?.value ?? "",
              })
            );
            dispatch(
              fetchClientPayoutBalance({
                clientId: selectedClient.value ?? "",
                resellerId: selectedReseller.value ?? "",
              })
            );

            dispatch(
              getAllDashboardVolumeCount({
                clientId: selectedClient.value ?? "",
                resellerId: selectedReseller.value ?? "",
                rootReferenceId: "",
                dateRange:
                  fromDate && toDate
                    ? moment(fromDate).format("DD/MM/YYYY") +
                      "-" +
                      moment(toDate).format("DD/MM/YYYY")
                    : "",
                serviceProviderName: selectedServiceProvider?.label,
              })
            );
            dispatch(
              getAllDashboardTransactionCount({
                clientId: selectedClient.value ?? "",
                resellerId: selectedReseller.value ?? "",
                rootReferenceId: "",
                dateRange:
                  fromDate && toDate
                    ? moment(fromDate).format("DD/MM/YYYY") +
                      "-" +
                      moment(toDate).format("DD/MM/YYYY")
                    : "",
                serviceProviderName: selectedServiceProvider?.label,
              })
            );
            onClose();
          }}
          buttonname1="Reset Filter"
          buttonname2="Apply"
        />
      </div>
    </div>
  );
}

export default FilterModal;
